export function toLookup<TKey extends PropertyKey, TValue, TItem extends TValue = TValue>(
	items: TItem[] | undefined | null,
	keySelector: (item: TItem, index: number) => TKey,
): Record<TKey, TItem> {
	const result = {} as Record<TKey, TItem>;

	if (!items) {
		return result;
	}

	items.forEach((item, index) => {
		const key = keySelector(item, index);
		const value = item;
		result[key] = value;
	});

	return result;
}
